/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-16T10:23:55-08:00
* @Email:  daniel@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-03-27T13:11:03-07:00
*/



import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import AutocompleteInput from '../../common/AutoCompleteInput';
import Headline from '../../common/Headline';
import UserConfig from '../../../config/User';
import InputGroup from '../../blocks/InputGroup';
import TextInput from '../../common/TextInput';
import Button from '../../blocks/Button';
import Panel from '../../common/Panel';
import RadioButton from '../../common/RadioButton';
import RadioButtonSet from '../../common/RadioButtonSet'
import Select from '../../common/Select';
import { css, StyleSheet } from 'aphrodite/no-important';
import { box, spacing, color } from '../../../style';
import HeaderOut from '../../blocks/HeaderOut';
import Container from '../../blocks/Container';
import { geocodeByPlaceId, extractLocationData } from '../../../common';

var currentYear = new Date().getFullYear();
var minimumSignupYear = currentYear-UserConfig.minimumAge;


const style = StyleSheet.create({

  panel: {
    ...box,
    backgroundColor: '#fff',
    ...spacing.PADDING_MD,
    ...spacing.MARGIN_BOTTOM_LG,
    ...spacing.MARGIN_TOP_SM
  },
  textLink: {
    cursor: 'pointer',
    color: color.BRAND_1_DARK
  },
});

class JoinS2 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      sex: 1,
      interested: 2,
      month: '',
      day: '',
      year: '',
      location: false,
      address: '',
      maximumMonth: 12, // used when checking to see someone is > 18
      maximumDay: 31,
    };
    this.sexChangeHandler = this.sexChangeHandler.bind(this);
    this.interestedInChangeHandler = this.interestedInChangeHandler.bind(this);
    this.monthChangeHandler = this.monthChangeHandler.bind(this);
    this.dayChangeHandler = this.dayChangeHandler.bind(this);
    this.yearChangeHandler = this.yearChangeHandler.bind(this);
    this.locationSelectHandler = this.locationSelectHandler.bind(this);
    this.resetLocation = this.resetLocation.bind(this);
    this.inputOnChange = this.inputOnChange.bind(this);
    this.setMaximums = this.setMaximums.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  sexChangeHandler(e) {
    let sex = parseInt(e.target.value);
    this.setState({sex});
  }

  interestedInChangeHandler(e) {
    let interested = parseInt(e.target.value);
    this.setState({interested});
  }

  dayChangeHandler(e) {
    let day = e.target.value;
    this.setState({day});
  }

  monthChangeHandler(e) {
    let month = e.target.value;
    this.setState({month});
    this.setMaximums(this.state.year,month);
  }

  yearChangeHandler(e) {
    let year = e.target.value;
    this.setState({year});
    this.setMaximums(year,this.state.month);
  }

  locationSelectHandler(address, placeId) {
    geocodeByPlaceId(placeId)
      .then((results) => {
        let location = results[0];
        let placeData = extractLocationData(location);
        let locText = `${placeData.city ? placeData.city + ', ' : ''}` +
          `${placeData.region ? placeData.region + ', ' : ''}` +
          `${placeData.country ? placeData.country : ''}`;

        if(location.geometry) {
          this.setState({ location, 'address': locText });
        }
      })
      .catch((error) => console.error('Issue with Geocoding: ', error));
  }

  /* set maximum month/day range */
  setMaximums(year,month) {
    // if the user is 18, restrict months.
    if(year == minimumSignupYear) {
      this.setState({
        maximumMonth: new Date().getMonth()+1,
        maximumDay: new Date().getDate()
      });
    } else {
      this.setState({
        maximumMonth: 12,
        maximumDay: new Date(year, month, 0).getDate()
      })
    }
  }

  /* drop down list options */
  dropDownOptions(start,end,rev, defaultValue) {
    var options = [];
    for(var i=start; i<=end; i++) {
      options.push(<option value={i} key={i.toString()}>{i}</option>);
    }
    if(rev) options.reverse();
    options.unshift(<option value="" disabled="true">{defaultValue}</option>);
    return options;
  }

  dropDownMonths(endMonth) {
    var Months = ['January','February','March','April','May','June','July','August',
    'September','October','November','December'];
    var options = [];
    options.push(<option value="" key="Month" disabled="true">Month</option>)
    for(var i=1; i<=endMonth; i++) {
      options.push(<option value={i} key={i.toString()}>{Months[i-1]}</option>)
    }
    return options;
  }

  resetLocation() {
    this.setState({location: false});
  }

  inputOnChange(value) {
    this.setState({address: value});
  }

  handleSubmit(e) {
    e.preventDefault();
    if(this.state.location) {
      // submit form - if location set.
      this.props.registerProfile(this.state);
    }
  }

  render() {
    const inputProps = {
      value: this.state.address || '',
      id: 'autocompleteLocation',
      placeholder: 'Enter a new location',
      type: 'text',
      className: ['textInput u-sizeFull'],
      onChange: this.inputOnChange
    };

    const canSubmit = Boolean(this.state.month && this.state.year && this.state.day && this.state.location)

    return (
      <Container width='thin' padding='large' screenTop>
        <Headline>
          Tell us a little bit about yourself.
        </Headline>
        <Panel padding='large'>
          <form id="register-profile" className="form-horizontal" onSubmit={this.handleSubmit}>
          {this.props.email ?
            <InputGroup vertical inputLabel="Your E-mail address">
              <span> {this.props.email} </span><Link className={css(style.textLink)} to="/logout"> (Not You?) </Link>
            </InputGroup> :
            null}

          <InputGroup vertical inputLabel="Your Gender">
            <RadioButtonSet>
              <RadioButton onChange={this.sexChangeHandler} value={1} checked={this.state.sex===1} >
                Male
              </RadioButton>
              <RadioButton onChange={this.sexChangeHandler} value={2} checked={this.state.sex===2} >
                Female
              </RadioButton>
            </RadioButtonSet>
          </InputGroup>

          <InputGroup vertical inputLabel="Interested in traveling with">
            <RadioButtonSet>
              <RadioButton onChange={this.interestedInChangeHandler} value={1} checked={this.state.interested===1} >
                Men
              </RadioButton>
              <RadioButton onChange={this.interestedInChangeHandler} value={2} checked={this.state.interested===2} >
                Women
              </RadioButton>
              <RadioButton onChange={this.interestedInChangeHandler} value={3} checked={this.state.interested===3} >
                Both
              </RadioButton>
            </RadioButtonSet>
          </InputGroup>
          <InputGroup vertical inputLabel="Your Birthdate">
              <Select extraStyles={{marginRight: '4px'}} onChange={this.monthChangeHandler} value={this.state.month}>
                {this.dropDownMonths(this.state.maximumMonth)}
              </Select>
              <Select extraStyles={{marginRight: '4px'}} onChange={this.dayChangeHandler} value={this.state.day}>
                {this.dropDownOptions(1,this.state.maximumDay,false, "Day")}
              </Select>
              <Select onChange={this.yearChangeHandler} value={this.state.year}>
                {this.dropDownOptions(currentYear-UserConfig.maximumAge,minimumSignupYear,true, "Year")}
              </Select>
          </InputGroup>
          <InputGroup vertical inputLabel="Your location">
            <AutocompleteInput
              inputProps={inputProps}
              onSelect={this.locationSelectHandler}
            />
            <input type="hidden" name="country" id="location-country" defaultValue />
            <input type="hidden" name="region" id="location-region" defaultValue />
            <input type="hidden" name="city" id="location-city" defaultValue />
            <input type="hidden" name="zip" id="location-zip" defaultValue />
            <input type="hidden" name="latitude" id="location-latitude" defaultValue />
            <input type="hidden" name="longitude" id="location-longitude" defaultValue />
            <p id="location-error" className="FormError hidden" />
          </InputGroup>
          <div className="buttonSet">
            {!canSubmit ?
              <Button fit variant='simple' type="submit" disabled={true}>
                Create your Account
              </Button>
              :
              <Button fit variant='primary' type="submit">
                Create your Account
              </Button>
            }

          </div>
        </form>
        </Panel>


      </Container>

    );
  }
}

export default JoinS2;



// WEBPACK FOOTER //
// ./src/components/pages/Join/JoinS2.jsx